<template>
  <el-dialog :visible.sync="dialogFormVisible" :title="titles[updateType]" :before-close="close" :close-on-click-modal="false">
    <el-form ref="form" label-width="160px" :model="initForm" :rules="rules">

          <!-- <el-form-item label="Email" prop="subscriber_email">
            <el-input v-model="initForm.subscriber_email" placeholder="请输入Email" :disabled="updateType === 'edit'"></el-input>
          </el-form-item> -->

          <el-form-item label="订阅者名称" prop="subscriber_name">
            <el-select
              v-model="initForm.subscriber_name"
              placeholder="请选择订阅者"
              filterable
              :disabled="updateType === 'edit'">
              <el-option
                v-for="name in subscriberNames"
                :key="name"
                :label="name"
                :value="name">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="云平台" prop="cloud">
            <el-select v-model="initForm.cloud" placeholder="请选择云平台">
              <el-option
                v-for="cloud in clouds"
                :label="cloud"
                :key="cloud"
                :value="cloud"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Dis账号">
            <template slot="label">
              Dis账号
              <el-tooltip effect="dark" content="请填写要订阅的Dis账号，一行一个Dis账号，如果为空表示订阅所有Dis" placement="top">
                <i class="el-icon-question"></i>
              </el-tooltip>
            </template>
            <el-input type="textarea" :rows="8" v-model="initForm.dis" placeholder="请填写Dis账号，如果为空，表示订阅所有Dis"></el-input>
          </el-form-item>

          <el-form-item label="备注">
            <el-input type="textarea" :rows="6" v-model="initForm.remark" placeholder="请填写备注"></el-input>
          </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button @click="$emit('close')" type="info">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { HasStatus } from "@/components/Index/data.js";

export default {
  props: {
    initForm: {},
    updateType: {},
    clouds: {},
    subscriberNames: { type: Array, default: () => [] }
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        subscriber_name: [{required: true, message: "请输入订阅者名称", trigger: "blur"}],
        cloud: [{required: true, message: "请选择云平台", trigger: "blur"}],
        dis: [{required: true, message: "Dis账号", trigger: "blur"}]
      },
      titles: {
        add: "新增",
        edit: "编辑"
      },
      businessDisStatus: HasStatus,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        var method = "";
        var url = "";
        var msg = "操作失败";
        var formData = {
              subscriber_name: this.initForm.subscriber_name,
              cloud: this.initForm.cloud,
              dis: this.initForm.dis,
              remark: this.initForm.remark
            };

        if (!valid) {alert("请检查输入是否正确！"); return false;};
        // this.dialogFormVisible = false;
        if (this.updateType === "add") {
          method = "post";
          url = "subscriber/sre-api/businesss_report_dis/";
          msg = "添加成功";
        } else if (this.updateType === "edit") {
          method = "patch";
          url = "subscriber/sre-api/businesss_report_dis/" + this.initForm.id + "/";
          msg = "编辑成功";
        } else{
          return false;
        };
        this.$http[method](
          url,
          formData,
          () => {
            this.$baseNotice.message(msg);
            this.$emit("close");
            this.$emit("update");
          }
        )
      });
    }
  }
};
</script>
